export const resumeBgVideo = () => {
  const video = document.querySelector(".js-top-bg-video");
  if (!video) return;

  document.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "visible" && video.paused) {
      video.play().catch(() => {});
    }
  });
};
